import { AuthState } from "../types/AmplifyAuth";
import { AuthWrapper } from "./AuthWrapper";

/**
 * Returns Amplify Register Flow
 * @returns
 */
export const Register = () => {
    return <AuthWrapper authState={AuthState.REGISTER} />;
};
